import Vue from 'vue'
import Vuex from 'vuex'
// import persistedState from 'vuex-persistedstate'

//挂载vuex
Vue.use(Vuex)

//创建Vuex对象
const store = new Vuex.Store({
    // plugins: [persistedState()],
    state: {
        openid:'', //okAXu0fLxAyEiN6gIk0wjMdugLgI
        historyUrl:''
    },
    mutations: {
        saveUserInfo(state,val){
            state.openid = val
        },
        saveUrl(state,val){
            state.historyUrl = val
        }
    },
    actions: {
        SAVEUSERACTION(context,payload){
            return new Promise((res,rej) => {
                context.commit('saveUserInfo',payload)
                res()
            })
        },
        SAVEURLACTION(context,payload){
            return new Promise((res) => {
                context.commit('saveUrl',payload)
                res()
            })
        }
    }
})

export default store